var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMergePdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.269531,
    width: 64,
    height: 64,
    rx: 12,
    fill: "#FFC1C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 32.2695H24C21.4858 32.2695 20.2287 32.2695 19.4477 33.0506C18.6666 33.8316 18.6666 35.0887 18.6666 37.6029V40.2695C18.6666 42.7837 18.6666 44.0408 19.4477 44.8218C20.2287 45.6029 21.4858 45.6029 24 45.6029H26.6666C29.1808 45.6029 30.4379 45.6029 31.2189 44.8218C32 44.0408 32 42.7837 32 40.2695V38.9362",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25.6029H30.6667C28.1525 25.6029 26.8955 25.6029 26.1144 26.384C25.3334 27.165 25.3334 28.4221 25.3334 30.9362V33.6029C25.3334 36.1171 25.3334 37.3741 26.1144 38.1552C26.8955 38.9362 28.1525 38.9362 30.6667 38.9362H33.3334C35.8475 38.9362 37.1046 38.9362 37.8857 38.1552C38.6667 37.3741 38.6667 36.1171 38.6667 33.6029V32.2696",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 24.2695C32 21.7553 32 20.4983 32.781 19.7172C33.5621 18.9362 34.8192 18.9362 37.3333 18.9362H40C42.5142 18.9362 43.7712 18.9362 44.5523 19.7172C45.3333 20.4983 45.3333 21.7553 45.3333 24.2695V26.9362C45.3333 29.4503 45.3333 30.7074 44.5523 31.4884C43.7712 32.2695 42.5142 32.2695 40 32.2695H37.3333C34.8192 32.2695 33.5621 32.2695 32.781 31.4884C32 30.7074 32 29.4503 32 26.9362V24.2695Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMergePdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mergePdf.6b97770e370ee8c87ea973999b663cec.svg";